import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import Text from '../../../basicElement/Text';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import Dimension from './Dimension';

let Constants = {};
const getStatusByType = (type) => {
    switch(type) {
        case 'add':
            return {
                add: true,
                title: '添加领域leader',
                saveUrl: API_URL.user.insertLeader,
            };
        case 'edit':
            return {
                edit: true,
                title: '修改领域leader',
                saveUrl: API_URL.user.updateLeader,
            }
    }
};
const getUid = () => Math.random();
const adaptData = (data) => {
    const { investigationAreaList, researchProductTypeList, stagings, businessLineList, projectCategoryList, investigationTypeList, fieldRelationList } = data;
    if (!(fieldRelationList || []).length) {
        return [];
    }

    const list = [];
    let diseaseIdx = 0;
    let productIdx = 0;
    let stageIdx = 0;
    let businessIdx = 0;
    let typeIdx = 0;
    let projectIdx = 0;
    for (let i = 0, len = fieldRelationList.length; i < len; i++) {
        const { responsibleFieldId, symbol } = fieldRelationList[i];
        const item = {
            id: getUid(),
            symbol: symbol || undefined,
            responsibleFieldId: String(responsibleFieldId),
        };
        if (responsibleFieldId === 1) {
            const { investigationAreaId, diseaseTypeId, diseaseList, criticalIllness: { decideCriticalIllnessId } = {} } = investigationAreaList[diseaseIdx];
            item.investigationAreaId = investigationAreaId ? String(investigationAreaId) : undefined;
            item.range = diseaseTypeId;
            item.diseaseDivide = decideCriticalIllnessId ? 'isCritical' : 'diseaseName';
            item.disease = diseaseList.map(i => ({ key: String(i.diseaseId), label: i.diseaseName }));
            item.isCritical = decideCriticalIllnessId ? String(decideCriticalIllnessId) : undefined;;
            diseaseIdx++;
        } else if (responsibleFieldId === 2) {
            const { researchProductTypes: [{ researchProductTypeId }] } = researchProductTypeList[productIdx];
            item.investigationMedicineType = researchProductTypeId ? String(researchProductTypeId) : undefined;
            productIdx++;
        } else if (responsibleFieldId === 3) {
            const { projectStagingList, projectStagingTypeList: [{ projectStagingTypeId, researchProductTypeList }] } = stagings[stageIdx];
            item.byStageId = projectStagingList.map(i => i.projectStagingId).join(',');
            item.range = projectStagingTypeId;
            item.investigationMedicineType = researchProductTypeList.map(i => i.researchProductTypeId).join(',');
            stageIdx++;
        } else if (responsibleFieldId === 4) {
            const { businessLines: [{ businessId }] } = businessLineList[businessIdx];
            item.lineOfBusiness = businessId ? String(businessId) : undefined;
            businessIdx++;
        } else if (responsibleFieldId === 5) {
            const { projectCategories: [{ categoryId }] } = projectCategoryList[typeIdx];
            item.typeId = categoryId ? String(categoryId) : undefined;
            typeIdx++;
        } else if (responsibleFieldId === 6) {
            const { investigationTypes: [{ investigationName, investigationTypeId }] } = investigationTypeList[projectIdx];
            item.range = investigationTypeId ? String(investigationTypeId) : undefined;
            item.text = investigationName || undefined;
            projectIdx++;
        }
        list.push(item);
    }
    return list;
}

class Update extends Component {
    state = {
        loading: false,
        visible: false,
        data: {},
    }

    loadData = () => {
        const { data } = this.state;
        const { leaderId } = data;
        this.setState({ loading: true });
        Fetch.post(API_URL.user.selectLeaderById, {
            leaderId
        }).then(res => {
            data.list = adaptData(res);
            this.setState({
                data,
                loading: false
            });
        }).catch(err => {
            console.error(err);
        });
    }

    show = (params, type) => {
        const { leaderId, userId, userCompellation, employeeCode } = params;
        Constants = getStatusByType(type);
        this.setState({
            data: {
                leaderId,
                userId,
                userName: userCompellation ? `${userCompellation}[${employeeCode}]` : undefined,
                list: [{
                    id: getUid(),
                    responsibleFieldId: '1'
                }]
            },
            visible: true
        }, () => {
            if (type === 'edit') {
                this.loadData();
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    handleChange = (value) => {
        const { data } = this.state
        data.userId = value.value;
        data.userName = value.text;
        data.enterpriseDepartmentId = value.enterpriseDepartmentId;
        this.setState({ data });
    }

    handleAdd = (type) => {
        const { data } = this.state;
        data.list.push({ id: getUid(), symbol: type, responsibleFieldId: '1' });
        this.setState({ data });
    }

    handleDelete = (index) => {
        const { data } = this.state;
        const { list } = data;
        list.splice(index, 1);
        if (index == 0) {
            list[0].symbol = undefined;
        }
        this.setState({ data });
    }

    handleListChange = (item, index) => {
        const { data } = this.state;
        data.list[index] = {...item};
        this.setState({ data });
    }

    confirm = () => {
        const { data } = this.state;
        const { userId, leaderId, enterpriseDepartmentId, list } = data;

        if (!userId) {
            message.warning('请选择领域leader!');
            return;
        }

        const params = {};
        let responsibleFieldIds = '';
        let diseaseIdx = 0;
        let productIdx = 0;
        let stageIdx = 0;
        let businessIdx = 0;
        let typeIdx = 0;
        let projectIdx = 0;
        let symbolIdx = 0;
        for (let i = 0, len = list.length; i < len; i++) {
            const item = list[i];
            const { symbol, responsibleFieldId } = item;
            responsibleFieldIds += responsibleFieldIds ? `,${responsibleFieldId}` : responsibleFieldId;
            if (item.responsibleFieldId == 1) {
                const { investigationAreaId, range, disease, isCritical } = item;
                if (!investigationAreaId || !range || (range == 2 && (!disease.length && !isCritical))) {
                    message.warning('请将项目领域填写完整!');
                    return;
                }
                params[`investigationAreaList[${diseaseIdx}].investigationAreaId`] = investigationAreaId;
                params[`investigationAreaList[${diseaseIdx}].diseaseTypeList[0].diseaseTypeId`] = range;
                if (disease.length) {
                    disease.forEach((item, index) => {
                        params[`investigationAreaList[${diseaseIdx}].diseaseTypeList[0].diseaseList[${index}].diseaseId`] = item.key;
                    });
                }
                if (isCritical) {
                    params[`investigationAreaList[${diseaseIdx}].diseaseTypeList[0].criticalIllness.criticalIllnessId`] = isCritical;
                }
                diseaseIdx++;
            } else if (item.responsibleFieldId == 2) {
                const { investigationMedicineType } = item;
                if (!investigationMedicineType) {
                    message.warning('请将研究产品类型填写完整!');
                    return;
                }
                params[`researchProductTypeList[${productIdx}].researchProductTypes[0].researchProductTypeId`] = investigationMedicineType;
                productIdx++;
            } else if (item.responsibleFieldId == 3) {
                const { byStageId, range, investigationMedicineType } = item;
                if (!byStageId || !range || (range == 2 && !investigationMedicineType)) {
                    message.warning('请将项目分期填写完整!');
                    return;
                }
                if (byStageId) {
                    const arr = byStageId.split(',');
                    arr.forEach((item, index) => {
                        params[`stagings[${stageIdx}].projectStagingList[${index}].projectStagingId`] = item;
                    });
                }
                params[`stagings[${stageIdx}].projectStagingTypeList[0].projectStagingTypeId`] = range;
                if (investigationMedicineType) {
                    const arr = investigationMedicineType.split(',');
                    arr.forEach((item, index) => {
                        params[`stagings[${stageIdx}].projectStagingTypeList[0].researchProductTypeList[${index}].researchProductTypeId`] = item;
                    });
                }
                stageIdx++;
            } else if (item.responsibleFieldId == 4) {
                const { lineOfBusiness } = item;
                if (!lineOfBusiness) {
                    message.warning('请将业务线填写完整!');
                    return;
                }
                params[`businessLineList[${businessIdx}].businessLines[0].businessLineId`] = lineOfBusiness;
                businessIdx++;
            } else if (item.responsibleFieldId == 5) {
                const { typeId } = item;
                if (!typeId) {
                    message.warning('请将项目分类填写完整!');
                    return;
                }
                params[`projectCategoryList[${typeIdx}].projectCategories[0].projectCategoryId`] = typeId;
                typeIdx++;
            } else if (item.responsibleFieldId == 6) {
                const { range, text } = item;
                if (!range || !text) {
                    message.warning('请将项目简称填写完整!');
                    return;
                }
                params[`investigationTypeList[${projectIdx}].investigationTypes[0].investigationTypeId`] = range;
                params[`investigationTypeList[${projectIdx}].investigationTypes[0].investigationName`] = text;
                projectIdx++;
            }
            params[`fieldRelationList[${symbolIdx}].symbol`] = symbol || '';
            params[`fieldRelationList[${symbolIdx}].responsibleFieldId`] = responsibleFieldId;
            symbolIdx++;
        }

        this.setState({ loading: true });
        Fetch.post(Constants.saveUrl, {
            userId,
            leaderId,
            responsibleFieldIds,
            enterpriseDepartmentId,
            ...params,
        }).then(res => {
            message.success(Constants.add ? "添加成功" : '修改成功');
            this.setState({
                visible: false,
                loading: false,
            }, () => {
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title={Constants.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                width="660px"
            >
                <div className="modal-content fieldLeader" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '20%' }}>
                                    <Text asterisk={Constants.add} colon={true}>领域leader</Text>
                                </div>
                                <div className="item-right" style={{ width: '80%' }}>
                                    <SearchRetrieve
                                        keyword="leaderName"
                                        placeholder="输入姓名/工号检索"
                                        style={{width: 160}}
                                        disabled={Constants.edit}
                                        value={data.userName}
                                        params={{limit: 20}}
                                        url={API_URL.user.queryLeaderList}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '20%' }}>
                                    <Text asterisk={true} colon={true}>负责领域</Text>
                                </div>
                                <div className="item-right" style={{ width: '80%' }}>
                                    <Dimension
                                        visible={visible}
                                        isEdit={Constants.edit}
                                        list={data.list || []}
                                        onClick={this.handleAdd}
                                        onDelete={this.handleDelete}
                                        onChange={this.handleListChange}
                                    />
                                </div>
                            </li>
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/Update.js